import { Button, useToast } from "alm-react-components";
import Lottie from "lottie-react";
import { useContext, useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";
import { ActionType, AppcuesConstant, constants, FileNotation, StatusCode } from "../../../../assets/constants/constants";
import {
  getExerciseCourse,
  getLottieFileContent,
  postExerciseCourse,
} from "../../../../services/user";
import DialogModal from "../../../common/DialogModal";
import { postRecommendedContent } from '../../../../services/ai.ts';
import { AppContext } from "../../../../context/AppProvider";
import getLocalizedContent from "../../../../lib/getLocalizedMetaData";
import useGaEventTracking from '../../../../hooks/UseGaEventTracking.tsx';
import { analytics_category, analytics_event, analytics_label, appcues_event } from '../../../../assets/constants/staticContentConstants.ts';
import { putAppCuesData } from "../../../../lib/appcues.ts";
type CourseCompleteProps = {
  updateCompletedCourse: any;
  currentLessionDetail:any;
  programData:any;
  exerciseModule:any;
};

export const CourseComplete: React.FC<CourseCompleteProps> = ({
  updateCompletedCourse,
  currentLessionDetail,
  programData,
  exerciseModule
}) => {
  const { t } = useTranslation();
  const { toast } = useToast();
  const [showModal, setShowModal] = useState<boolean>(false);
  const [exerciseLottieJson, setExerciseLottieJson] = useState<string>("");
  const [isCourseComplete, setIsCourseComplete] = useState<boolean>(false);
  const [isLoading, setLoading] = useState<boolean>(false);
  const {state,dispatch} = useContext(AppContext);
  const gaEventTracker = useGaEventTracking();

  const navigate = useNavigate();
  useEffect(()=>{
    currentLessionDetail?.supplementaryResources?.forEach((val: any) => {
      programData?.included?.find((ele: any) => {
        if (ele.id === val.id) {
          const file = ele.attributes.name;
          if (file.endsWith(FileNotation.finish) && ele?.attributes?.location) {

            getLottieFileContent(ele?.attributes?.location).then((res: any) => {
              if (res.status === StatusCode.SUCCESS) setExerciseLottieJson(res.data);
            });
          } 
        }
      });
    })
  },[currentLessionDetail]);
 

  const getCourseStatus = (flag: boolean) => {
    getExerciseCourse(currentLessionDetail.id,exerciseModule).then((res: any) => {
      if (res.status === StatusCode.SUCCESS) {
        const { attemptNumber, isCourseCompleted } = res.data;
        // show complete button, show lottie image, api update isCourseCompleted=1;
        setLoading(true)
        if (attemptNumber == 0) {
          // If course user not start the course
          if (!flag)
            toast({
              description: t("Common.courseCompletionError"),
              variant: "error",
            });
        } else if (attemptNumber > 0 && isCourseCompleted == 0) {
          if (!flag) doCompleteCourse();
        } else if (attemptNumber > 0 && isCourseCompleted == 1) {
          const today = new Date();
          const items = {
            value: null,
            currency: null,
            transaction_id: null,
            items: [{}],
            user_id:state.user?.userId,
            program_name:currentLessionDetail.programName,
            course_name:currentLessionDetail.name,
            completion_date:today.toLocaleDateString(),
            completion_status:"Yes"
        };      
      gaEventTracker(analytics_event.exerciseCompleted,analytics_category.buttonClickExerciseActivity,analytics_label.exerciseFinishedLable,items);
      putAppCuesData({
        event_Name:appcues_event.lessonCompleted,
        eventName:`${appcues_event.lessonCompleted}_${currentLessionDetail?.id}_${currentLessionDetail?.name}`,
        userId: state.user?.email || "",
        lesson_id: currentLessionDetail?.id,
        lesson_name: currentLessionDetail?.name,
        program_id:programData.data.id,
        lesson_type:AppcuesConstant.exercise,
        event_timestamp: new Date().toISOString(),
    })
          //Show course completed
          setIsCourseComplete(true);
        }
      }else if(res.status === StatusCode.ERR_NETWORK)  {
        setLoading(true)
        toast({
          description: t("ErrorType.retryAgain"),
          variant: "error",
        });
      }else{
        setLoading(true)
        toast({
          description: t("Common.courseCompletionError"),
          variant: "error",
        });
      }
    });
  };

  useEffect(() => {
    getCourseStatus(true);
  }, []);

  const doCompleteCourse = async() => {
    const params={
      programId: programData.data.id,
      programName:getLocalizedContent(
        programData?.data?.attributes?.localizedMetadata,constants.dutchLocale
      )?.name.trim()
    }
    dispatch({type: ActionType.SET_LOADING, payload: true});

    await postExerciseCourse(currentLessionDetail.id,params)
      .then((res: any) => {
        if (res.status === StatusCode.SUCCESS) {
           postRecommendedContent({
            user_id: state.user?.userId,
            program_name: currentLessionDetail.programName.trim()
           })
          setShowModal(true);
          updateCompletedCourse(currentLessionDetail.id);
          setIsCourseComplete(true);
          const today = new Date();
          const items = {
            value: null,
            currency: null,
            transaction_id: null,
            items: [{}],
            user_id:state.user?.userId,
            program_name:currentLessionDetail.programName,
            course_name:currentLessionDetail.name,
            completion_date:today.toLocaleDateString(),
            completion_status:"Yes"
        };      
      gaEventTracker(analytics_event.exerciseCompleted,analytics_category.buttonClickExerciseActivity,analytics_label.exerciseFinishedLable,items);
      putAppCuesData({
        event_Name:appcues_event.lessonCompleted,
        eventName:`${appcues_event.lessonCompleted}_${currentLessionDetail?.id}_${currentLessionDetail?.name}`,
        userId: state.user?.email || "",
        lesson_id: currentLessionDetail?.id,
        lesson_name: currentLessionDetail?.name,
        program_id:programData.data.id,
        lesson_type:AppcuesConstant.exercise,
        event_timestamp: new Date().toISOString(),
    })
        } else {
          toast({
            description: t("Common.courseCompletionError"),
            variant: "error",
          });
        }
      })
      .catch((error: any) => console.log(error));
      dispatch({type: ActionType.SET_LOADING, payload: false});
      

  };

  const buttonElement = () => {
    return isCourseComplete ? (
      <Button
        variant={"secondary"}
        className="inline-flex items-center justify-center rounded-sm text-base font-opensansSemiBold w-full my-4 ml-4 py-4 px-4 h-10"
      >
        <span dangerouslySetInnerHTML={{ __html: t("Common.completed") }} />
      </Button>
    ) : (
      <Button
        onClick={() => getCourseStatus(false)}
        variant={"default"}
        className="inline-flex items-center justify-center rounded-sm text-base font-opensansSemiBold w-full my-4 ml-4 py-4 px-4 h-10"
      >
        <span dangerouslySetInnerHTML={{ __html: t("Common.complete") }} />
      </Button>
    );
  };

  const closeModel = () => {
    setShowModal(false);
  };

  const viewRecommendedContent = async () => {
    navigate('/home/library');
    setShowModal(false);
  };
  return (
    <div className="pb-4 flex">
      {showModal && (
        <DialogModal
          open={true}
          onClose={closeModel}
          title={currentLessionDetail.programName}
          body={<Lottie animationData={exerciseLottieJson} loop={true} className="lottie-card" />}
          onButtonClick={viewRecommendedContent}
        />
      )}
      {isLoading && buttonElement()}
    </div>
  );
};
